var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"actions\"\u003E\u003Cbutton class=\"btn btn-same-width background-marine round\" ng-if=\"$ctrl.store.viewState === 'state-visitor'\" ng-click=\"$ctrl.goToResult()\"\u003ERetour au devis\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-same-width background-light-pink round\" ng-click=\"$ctrl.clickOnSubscribePlum()\"\u003EJe passe chez Plüm\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/states/quotation/component/quotationResultActions.jade
// module id = 1119
// module chunks = 1